// extracted by mini-css-extract-plugin
export default {"layout":"LayoutWrapper_layout__YjvDy","contentContainer":"LayoutWrapper_contentContainer__w8tYY","content":"LayoutWrapper_content__jCtHQ","footer":"LayoutWrapper_footer__ijEQ0"};